import posthog from 'posthog-js';

if (process.env.NEXT_PUBLIC_POSTHOG_KEY) {
  posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
    api_host: 'https://eu.posthog.com',
    autocapture: false,
    capture_pageview: false,
    capture_pageleave: false,
  });
}

// This error reporter checks for errors that originates from the widget shadow root stack.
const captureError = (error: Error) => {
  if (error.stack?.includes('onlineti://')) {
    posthog.captureException(error);
  }
};

const handleError = (errorEvent: ErrorEvent) => {
  if (errorEvent.error instanceof Error) {
    captureError(errorEvent.error);
  }
};

const handleUnhandledRejection = (rejectionEvent: PromiseRejectionEvent) => {
  if (rejectionEvent.reason instanceof Error) {
    captureError(rejectionEvent.reason);
  }
};

window.addEventListener('error', handleError);
window.addEventListener('unhandledrejection', handleUnhandledRejection);
